import { StartClient } from "@tanstack/react-start/client";
import { hydrateRoot } from "react-dom/client";
import "./styles.css";

hydrateRoot(document, <StartClient />);
